import {
  SortDirectionEnum,
  UlohyOrganizacie as UlohyOrganizacieGenerated,
  UlohyOrganizacieApi,
  UlohyOrganizaciePage,
} from 'elegislativa-frontend-ts-axios';
import { ClientResponse } from '../../model/ClientResponse';
import apiConfiguration from '../configuration/apiConfiguration';
import { elegislativaPrefixPath } from '../configuration/apiConfigurationConstants';
import UlohyOrganizacieListPage from '../../model/legislativnyMaterial/UlohyOrganizacieListPage';
import UlohyOrganizacie from '../../model/legislativnyMaterial/UlohyOrganizacie';
import { mapSubject } from '../../model/legislativnyMaterial/SubjectItem';

const client = new UlohyOrganizacieApi(apiConfiguration(elegislativaPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const fetchUlohyOrganizacie = async (
  page?: number,
  size?: number,
  sortBy?: string,
  sortDirection?: SortDirectionEnum,
  meno?: string,
  headers?: object,
): Promise<ClientResponse<UlohyOrganizacieListPage>> => {
  const mapUlohaOrganizacie = (data: UlohyOrganizacieGenerated): UlohyOrganizacie => ({
    pocetUloh: data.pocetUloh,
    subject: mapSubject(data.subject),
  });

  const map = (data: UlohyOrganizaciePage): UlohyOrganizacieListPage => ({
    ulohyOrganizacie: data.ulohyOrganizacie.map(ulohaOrg => mapUlohaOrganizacie(ulohaOrg)),
    number: data.number,
    size: data.size,
    totalElements: data.totalElements,
  });

  const {
    data,
    status,
  } = await client
    .getUlohyOrganizacie(page, size, sortBy, sortDirection, meno, headers);
  return {
    data: map(data),
    responseCode: status,
  };
};
